import { render, staticRenderFns } from "./DetalleDevolucion.vue?vue&type=template&id=27583006"
import script from "./DetalleDevolucion.vue?vue&type=script&lang=js"
export * from "./DetalleDevolucion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports